import { render } from "./FaceIdAttemptsTable.vue?vue&type=template&id=55ca38dc&scoped=true"
import script from "./FaceIdAttemptsTable.vue?vue&type=script&lang=js"
export * from "./FaceIdAttemptsTable.vue?vue&type=script&lang=js"

import "./FaceIdAttemptsTable.vue?vue&type=style&index=0&id=55ca38dc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ca38dc"]])

export default __exports__